/* tslint:disable */
/* eslint-disable */
/**
 * GlassHouse.Dashboard.Api | v1
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { SetEmployeeRolesResponse } from './SetEmployeeRolesResponse';
import {
    SetEmployeeRolesResponseFromJSON,
    SetEmployeeRolesResponseFromJSONTyped,
    SetEmployeeRolesResponseToJSON,
    SetEmployeeRolesResponseToJSONTyped,
} from './SetEmployeeRolesResponse';

/**
 * 
 * @export
 * @interface ResultOfSetEmployeeRolesResponse
 */
export interface ResultOfSetEmployeeRolesResponse {
    /**
     * 
     * @type {SetEmployeeRolesResponse}
     * @memberof ResultOfSetEmployeeRolesResponse
     */
    data: SetEmployeeRolesResponse | null;
    /**
     * 
     * @type {boolean}
     * @memberof ResultOfSetEmployeeRolesResponse
     */
    isSuccess: boolean;
    /**
     * 
     * @type {Error}
     * @memberof ResultOfSetEmployeeRolesResponse
     */
    error: Error | null;
}

/**
 * Check if a given object implements the ResultOfSetEmployeeRolesResponse interface.
 */
export function instanceOfResultOfSetEmployeeRolesResponse(value: object): value is ResultOfSetEmployeeRolesResponse {
    if (!('data' in value) || value['data'] === undefined) return false;
    if (!('isSuccess' in value) || value['isSuccess'] === undefined) return false;
    if (!('error' in value) || value['error'] === undefined) return false;
    return true;
}

export function ResultOfSetEmployeeRolesResponseFromJSON(json: any): ResultOfSetEmployeeRolesResponse {
    return ResultOfSetEmployeeRolesResponseFromJSONTyped(json, false);
}

export function ResultOfSetEmployeeRolesResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): ResultOfSetEmployeeRolesResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'data': SetEmployeeRolesResponseFromJSON(json['data']),
        'isSuccess': json['isSuccess'],
        'error': json['error'],
    };
}

export function ResultOfSetEmployeeRolesResponseToJSON(json: any): ResultOfSetEmployeeRolesResponse {
    return ResultOfSetEmployeeRolesResponseToJSONTyped(json, false);
}

export function ResultOfSetEmployeeRolesResponseToJSONTyped(value?: ResultOfSetEmployeeRolesResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'data': SetEmployeeRolesResponseToJSON(value['data']),
        'isSuccess': value['isSuccess'],
        'error': value['error'],
    };
}

